export enum LogisticTypeName {
  manual = 'MANUAL',
  automatic = 'AUTOMATIC',
  local = 'LOCAL',
  automatic_doorstep = 'AUTOMATIC_DOORSTEP',
  manual_doorstep = 'MANUAL_DOORSTEP',
}
